import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { StatusNotificationsService } from '@services/entity/statusNotifications.services';
import { CustomersService } from '@services/entity/customers.service';
import { RunningTransactionTechnicalDto } from '@dto/runningTransactionTechnicalDto';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { StatusNotificationsDto } from '@dto/statusNotificationDto';

@Component({
  selector: 'app-technical-dashboard',
  templateUrl: './technical-dashboard.component.html',
  styleUrls: ['./technical-dashboard.component.scss']
})
export class TechnicalDashboardComponent implements OnInit {
  chargingStations: ChargingStationDto[] = [];
  runningTransactions: RunningTransactionTechnicalDto[] = [];
  statusNotifications: StatusNotificationsDto[] = [];
  loadingStations = true;
  loadingTransactions = true;
  loadingNotifications = true;
  /** Headline: InternalDescription des Kunden oder Fallback „Technisches Dashboard“. */
  dashboardTitle = '';
  readonly defaultTitle = $localize`:@@TechnicalDashboardTitle:Technisches Dashboard`;

  constructor(
    private chargingStationsService: ChargingStationsService,
    private transactionsService: TransactionsService,
    private statusNotificationsService: StatusNotificationsService,
    private customersService: CustomersService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.customersService.getSelectedCustomer().subscribe({
      next: (customer) => {
        this.dashboardTitle = (customer?.internalDescription?.trim()) || '';
      },
      error: () => {}
    });
    this.chargingStationsService.getChargingStationsOfCurrentCustomer().subscribe({
      next: (list) => {
        this.chargingStations = list || [];
        this.loadingStations = false;
      },
      error: () => { this.loadingStations = false; }
    });
    this.transactionsService.getRunningTransactionsTechnical().subscribe({
      next: (list) => {
        this.runningTransactions = list || [];
        this.loadingTransactions = false;
      },
      error: () => { this.loadingTransactions = false; }
    });
    this.statusNotificationsService.getStatusNotificationsForCurrentCustomer(100).subscribe({
      next: (list) => {
        this.statusNotifications = list || [];
        this.loadingNotifications = false;
      },
      error: () => { this.loadingNotifications = false; }
    });
  }

  goToChargingStations(): void {
    this.router.navigate(['/technical/charging-stations']);
  }

  trackByTransactionId(_index: number, tx: RunningTransactionTechnicalDto): number | string {
    return tx?.id ?? tx?.transactionId ?? _index;
  }

  getChargingPointLabel(tx: RunningTransactionTechnicalDto): string {
    if (!tx?.chargingStationNumberOfChargingPoints || tx.chargingStationNumberOfChargingPoints <= 1) return '';
    return tx.connectorId != null ? `(Ladepunkt ${tx.connectorId})` : '';
  }

  getStatusBadgeClass(statusId: number): string {
    switch (statusId) {
      case 1: return 'bg-primary';
      case 2: return 'bg-success';
      case 3: return 'bg-warning';
      case 4: return 'bg-danger';
      case 5:
      case 6:
      case 8:
      case 9: return 'bg-info';
      case 7: return 'bg-reserved';
      case 10: return 'bg-danger';
      case 11: return 'bg-secondary';
      default: return 'bg-secondary';
    }
  }
}
